import React, { createContext, useState } from 'react'

export const TooltipContext = createContext({
  shownTooltip: null,
  setShownTooltip: (tooltipText) => {},
})

const TooltipProvider = ({ children }) => {
  const [shownTooltip, setShownTooltip] = useState(null)
  return (
    <TooltipContext.Provider value={{ setShownTooltip, shownTooltip }}>
      {children}
    </TooltipContext.Provider>
  )
}

export default TooltipProvider
